/**
 * Get absolute xPath position from dom element
 * xPath position will does not contain any id, class or attribute, etc selector
 * Because, Some page use random id and class. This function should ignore that kind problem, so we're not using any selector
 *
 * @param {Element} element element to get position
 * @returns {String} xPath string
 */
export function getXPath(element: Element | null): string {
  if (element === null) {
    return '';
  }

  // Selector
  let selector = '';
  // Loop handler
  let foundRoot;
  // Element handler
  let currentElement = element;

  // Do action until we reach html element
  do {
    // Get element tag name
    const tagName = currentElement.tagName.toLowerCase();
    // Get parent element
    const parentElement = currentElement.parentElement;

    if (parentElement === null) {
      return '';
    }

    // Count children
    if (parentElement.childElementCount > 1) {
      // Get children of parent element
      const parentsChildren = Array.from(parentElement.children);
      // Count current tag
      const tag: Element[] = parentsChildren.filter((child) => child.tagName.toLowerCase() === tagName);

      // Is only of type
      if (tag.length === 1) {
        // Append tag to selector
        selector = `/${tagName}${selector}`;
      } else {
        // Get position of current element in tag
        const position = tag.indexOf(currentElement) + 1;
        // Append tag to selector
        selector = `/${tagName}[${position}]${selector}`;
      }
    } else {
      //* Current element has no siblings
      // Append tag to selector
      selector = `/${tagName}${selector}`;
    }

    // Set parent element to current element
    currentElement = parentElement;
    // Is root
    foundRoot = parentElement.tagName.toLowerCase() === 'html';
    // Finish selector if found root element
    if (foundRoot) selector = `/html${selector}`;
  } while (foundRoot === false);

  // Return selector
  return selector;
}
